import { render, staticRenderFns } from "./savewithsub.vue?vue&type=template&id=754d873d&scoped=true"
import script from "./savewithsub.vue?vue&type=script&lang=js"
export * from "./savewithsub.vue?vue&type=script&lang=js"
import style0 from "./savewithsub.vue?vue&type=style&index=0&id=754d873d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754d873d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/rakarapu/compiere-all/pharmanord2011/template/webapps/buybuttoncompact/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('754d873d')) {
      api.createRecord('754d873d', component.options)
    } else {
      api.reload('754d873d', component.options)
    }
    module.hot.accept("./savewithsub.vue?vue&type=template&id=754d873d&scoped=true", function () {
      api.rerender('754d873d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/savewithsub.vue"
export default component.exports